import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import SelectSiteGroupComponent from "../../../components/site/select-site-group.component";
import SelectSiteComponent from "../../../components/site/select-site.component";
import { EDITABLE_FLAG, codeMasterType } from "../../../config/constants";
import codeMasterModel from "../../../models/common/code-master.model";
import GscmDivisionModel from "../../../models/gscm-division/gscm-division.model";
import languageModel from "../../../models/language.model";
import SiteSoldToShipToMappingModel from "../../../models/sold-to-ship-to/site-sold-to-ship-to-mapping.model";
import ViewBase from "../../view-base.view";
import SiteSoldToShipToAddView from "./site-sold-to-ship-to-mapping-add.view";
import SiteSoldToShipToMappingExcelUploadDialog from "./site-sold-to-ship-to-mapping.excel-upload.dialog";
import { downloadUserFileByFileID } from "../../../models/file.model"
import moment from "moment";
import { formats } from "../../../config/constants";
/**
 * Site Sold-To Ship-To Mapping View
 *
 * 
 *
 * @author cmc.nttruong1
 */
export default function SiteSoldToShipToMappingView() {
  ViewBase.call(this);

  const SELECT_ALL_CHECKBOX_ID = "soldToShipToMappingSelectAllCheckbox";
  const CHECKBOX_NAME = "soldToShipToMappingCheckbox";

  const DEFAULT_FILTERS = {
    sites: [],
    gscmDivisions: [],
    siteGroups: [],
    storeStatuses: [],
    imceTypeChoice: "",
    editableFlag: "",
    showOnlyEmptySoldto: false,
    // gscmStoreStatusesText: "",
  };

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0,
  };

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  let soldToShipToMapping = [];
  let selectedSoldToShipToMapping = [];

  let isExcelUploaded = false;
  let isModalMappingOpen = false;
  let mappingDetail = null;

  let gscmDivisionsOptionList = [];
  let siteStatusOptionList = [];
  let imceOptionList = [];
  let editableFlagList = Object.values(EDITABLE_FLAG).map((element) => ({
    sequence: 0,
    code: element,
    name: element,
  }));
  let isSelectedShowOnlyEmptySoldto = false;
  let isExcelUploadOpen = false;

  let _openModalMapping = (data) => {
    isModalMappingOpen = true;
    isExcelUploadOpen = false;
    mappingDetail = data;
  };

  const downloadExcel = () => {
    this.showLoading();
    SiteSoldToShipToMappingModel.downloadExcel(toQueryParams(filters))
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const selectRow = (checked, item) => {
    if (checked) {
      selectedSoldToShipToMapping.push({
        siteId: item.siteId,
        gscmDivision: item.gscmDivision,
        soldToCode: item.soldtoCode,
        shipToCode: item.shiptoCode,
        distributionStoreType: item.distributionStoreType,
      });
    } else {
      selectedSoldToShipToMapping = selectedSoldToShipToMapping.filter(
        (data) => data.UID !== item.UID
      );
    }

    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    if (selectedSoldToShipToMapping.length === 0) {
      selectAllCheckbox.indeterminate = false;
      selectAllCheckbox.checked = false;
    } else if (
      selectedSoldToShipToMapping.length ===
      soldToShipToMapping.filter((item) => item.editableYN).length
    ) {
      selectAllCheckbox.indeterminate = false;
      selectAllCheckbox.checked = true;
    } else {
      selectAllCheckbox.indeterminate = true;
      selectAllCheckbox.checked = false;
    }
  };

  const _dataMapping = (param) => {
    return Object.assign({
      siteId: param.siteId,
      gscmDivision: param.gscmDivision,
      soldToCode: param.soldtoCode,
      shipToCode: param.shiptoCode,
      distributionStoreType: param.distributionStoreType,
    });
  };

  const toQueryParams = (param) => {
    return Object.assign({
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
      sites: param.sites.map((e) => e.code),
      gscmDivisions: param.gscmDivisions.map((e) => e.code),
      siteGroups: param.siteGroups.map((e) => e.code),
      storeStatuses: param.storeStatuses.map((e) => e.code),
      imceTypeChoice: param.imceTypeChoice ? param.imceTypeChoice.code : "",
      editableFlag: param.editableFlag ? param.editableFlag.code : "",
      showOnlyEmptySoldto: param.showOnlyEmptySoldto,
      orderBy: "",
      sortBy: "",
    });
  };

  const searchSoldToShipToMapping = () => {
    this.showLoading();
    uncheckAllCheckboxes();
    SiteSoldToShipToMappingModel.getListSoldToShipTo(toQueryParams(filters))
      .then((result) => {
        soldToShipToMapping = [];

        if (result != null) {
          soldToShipToMapping = result.data;
          pagination.totalItems = result.total;
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const _initControls = () => {
    getSiteStatusList();
    getImceList();
    getGscmDivisionsList();
    searchSoldToShipToMapping();
  };

  const getSiteStatusList = () => {
    siteStatusOptionList = [];
    return codeMasterModel
      .getByCategoryV2({ category: codeMasterType.siteStatus })
      .then((result) => {
        siteStatusOptionList = result;
      })
      .catch((error) => {
        this.handleError(error);
      });
  };

  const getGscmDivisionsList = () => {
    return GscmDivisionModel.getGscmDivisions()
      .then((results) => {
        gscmDivisionsOptionList = results;
      })
      .catch((error) => {
        this.handleError(error);
      });
  };

  const getImceList = () => {
    imceOptionList = [];
    return codeMasterModel
      .getByCategoryV2({ category: codeMasterType.imceType })
      .then((result) => {
        imceOptionList = result;
      })
      .catch((error) => {
        this.handleError(error);
      });
  };

  const selectShowChanged = (e) => {
    if (e.target.checked) {
      isSelectedShowOnlyEmptySoldto = true;
      filters.showOnlyEmptySoldto = true;
    } else {
      isSelectedShowOnlyEmptySoldto = false;
      filters.showOnlyEmptySoldto = false;
    }
    m.redraw();
  };

  const clearFilter = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    pagination = structuredClone(DEFAULT_PAGINATION);
    searchSoldToShipToMapping();
  };

  const onCheckAll = (event) => {
    let checkboxes = document.querySelectorAll(
      `input[type='checkbox'][name='${CHECKBOX_NAME}']`
    );

    selectedSoldToShipToMapping = [];

    if (event.target.checked || event.target.indeterminate) {
      soldToShipToMapping.forEach((item) => {
        if (item.remark === EDITABLE_FLAG.EDITABLE) {
          selectedSoldToShipToMapping.push({
            siteId: item.siteId,
            gscmDivision: item.gscmDivision,
            soldToCode: item.soldtoCode,
            shipToCode: item.shiptoCode,
            distributionStoreType: item.distributionStoreType,
          });
        }
      });

      checkboxes.forEach((item) => {
        item.checked = true;
      });
    } else {
      checkboxes.forEach((item) => {
        item.checked = false;
      });
    }
    event.target.indeterminate = false;
  };

  const uncheckAllCheckboxes = () => {
    const arr = document.querySelectorAll(`input[name=${CHECKBOX_NAME}]`);
    if (arr.length === 0) {
      return;
    }
    arr.forEach((checkbox) => {
      checkbox.checked = false;
    });
    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    selectAllCheckbox.indeterminate = false;
    selectAllCheckbox.checked = false;

    selectedSoldToShipToMapping = [];
  };

  const onDeleteAction = () => {
    if (selectedSoldToShipToMapping.length > 0) {
      this.showConfirm(
        this.getText("EM00000265", "Are you sure you want to delete?"),
        this.getText("LT00000373", "Remove Selected"),
        (e) => {
          if (e == "YES") {
            SiteSoldToShipToMappingModel.deleteMapping(
              selectedSoldToShipToMapping
            )
              .then((result) => {
                _initControls();

                this.showConfirm(
                  this.getText(
                    "",
                    `Success: ${result.success} results. Failure: ${result.failure} results`
                  ),
                  this.getText(
                    "LT00000828",
                    "Do you want to download result file?"
                  ),
                  (e) => {
                    if (e == "YES") {
                      const fileName = `MassActionResultSiteSoldToShipToMapping_${moment().format(formats.apiDateFormat)}`
                      downloadUserFileByFileID(
                        result.fileId, fileName
                      );
                    }
                  }
                );
              })
              .catch(() => {
                this.showErrorMessage(this.getText("EM00000142", "Error"));
              });
          }
        }
      );
    } else {
      this.showErrorMessage(this.getText("LT00000719", "No items selected"));
    }
  };

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;
    searchSoldToShipToMapping();
  };

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    searchSoldToShipToMapping();
  };

  return {
    oninit: () => {
      _initControls();
    },
    onupdate: () => {
      if (isExcelUploaded) {
        this.showMessage(
          this.getText('EM00000312', 'Please check the detailed upload result in the downloaded file'),
          this.getText('EM00000313', 'Upload Completed'),
        )
        isExcelUploaded = false;
      }
    },
    view: () => {
      return [
        m(".d-flex.justify-content-end.align-items-end.mb-3",
          m("button.btn.btn-outline-primary.btn-add.mb-2",
            {
              onclick: () => {
                _openModalMapping(null);
              },
            },
            m("i.bi.bi-plus-lg.me-0")
          )
        ),

        // /* SEARCH */
        m(
          ".d-flex.flex-column.align-items-end.gap-2.mb-3",
          m(
            'a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="false"]',
            m("i.bi.bi-filter"),
            this.getText("LT00000232", "Filter")
          ),
          m(".collapse.show#search-section.w-100",
            m(".card",
              m(".card-body",
                m(
                  ".row.g-2",

                  m(
                    ".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000516", "Site(s)")),
                    m(SelectSiteComponent, {
                      selectedItemList: filters.sites,
                      onChange: (s) => {
                        filters.sites = s;
                      },
                    })
                  ),

                  m(
                    ".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000814", "GSCM Division(s)")),
                    m(MultiSelectComponent, {
                      id: "gscmDivisions",
                      items: gscmDivisionsOptionList,
                      selectedItems: filters.gscmDivisions,
                      onSelect: (s) => {
                        filters.gscmDivisions = s;
                      },
                    })
                  ),

                  m(
                    ".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000815", "GSCM Site Group(s)")),
                    m(SelectSiteGroupComponent, {
                      selectedItems: filters.siteGroups,
                      onChange: (s) => {
                        filters.siteGroups = s;
                      },
                    })
                  ),

                  m(
                    ".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000816", "GSCM Site Status(s)")),
                    m(MultiSelectComponent, {
                      id: "gscmStoreStatuses",
                      items: siteStatusOptionList,
                      selectedItems: filters.storeStatuses,
                      onSelect: (s) => {
                        filters.storeStatuses = s;
                      },
                    })
                  ),

                  m(
                    ".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000817", "IM/CE Store")),
                    m(SingleSelectComponent, {
                      id: "imce",
                      items: imceOptionList,
                      selectedItem: filters.imceTypeChoice,
                      checkmark: true,
                      filterable: true,
                      required: true,
                      onSelect: (s) => {
                        filters.imceTypeChoice = s;
                      },
                    })
                  ),

                  m(
                    ".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000854", "Editable Flag")),
                    m(SingleSelectComponent, {
                      id: "editableFlag",
                      items: editableFlagList,
                      selectedItem: filters.editableFlag,
                      checkmark: true,
                      filterable: true,
                      required: true,
                      onSelect: (s) => {
                        filters.editableFlag = s;
                      },
                    })
                  ),

                  m(
                    ".col-md-3.col-lg-3.position-relative.d-flex.align-items-center",
                    m(".form-check", [
                      m(
                        "input.form-check-input#show-only-empty-show-to[type=checkbox]",
                        {
                          checked: isSelectedShowOnlyEmptySoldto,
                          onchange: selectShowChanged,
                        }
                      ),
                      m(
                        "label.form-check-label[for=show-only-empty-show-to]",
                        this.getText("LT00000846", "Show Only Empty Show-To")
                      ),
                    ])
                  ),

                  m(
                    ".col-12.d-flex.justify-content-end.gap-2",
                    m(
                      "button.btn.btn-primary",
                      {
                        onclick: () => {
                          pagination = structuredClone(DEFAULT_PAGINATION);
                          searchSoldToShipToMapping();
                        },
                      },
                      this.getText("LT00000001", "Search")
                    ),
                    m(
                      "button.btn.btn-white",
                      {
                        type: "button",
                        onclick: () => {
                          clearFilter();
                        },
                      },
                      this.getText("LT00000031", "Clear")
                    )
                  )
                )
              )
            )
          )
        ),

        // /* TABLE */
        m(
          ".card",
          m(
            ".card-body",
            m(
              ".row.g-2",
              m(
                ".col-12.d-flex.justify-content-between",
                m(
                  ".d-flex.gap-2",
                  m(
                    "button.btn.btn-danger",
                    {
                      onclick: () => {
                        onDeleteAction();
                      },
                    },
                    this.getText("LT00000821", "Delete Selected")
                  )
                ),
                m(
                  ".d-flex.gap-2",
                  m(
                    "button.btn.btn-primary",
                    {
                      onclick: () => {
                        isExcelUploadOpen = true;
                      },
                    },
                    m("i.bi.bi-file-earmark-arrow-up-fill"),
                    this.getText("LT00000197", "Excel Upload")
                  ),
                  m(
                    "button.btn.btn-primary",
                    { onclick: downloadExcel },
                    m("i.bi.bi-file-earmark-arrow-down-fill"),
                    this.getText("LT00000018", "Excel Download")
                  )
                )
              ),
              m(
                ".col-12",
                m(
                  ".table-responsive",
                  m(
                    "table.table.table-hover.sticky-column-start",
                    m(
                      "thead",
                      m(
                        "tr.align-middle",
                        m(
                          "th",
                          m("input", {
                            tabindex: -1,
                            id: SELECT_ALL_CHECKBOX_ID,
                            type: "checkbox",
                            onchange: onCheckAll,
                          })
                        ),
                        m("th", this.getText("LT00000817", "IM/CE Store")),
                        m("th", this.getText("LT00000809", "Site ID")),
                        m("th", this.getText("LT00000144", "Site Name")),
                        m("th", this.getText("LT00000844", "GSCM Site Group")),
                        m("th", this.getText("LT00000845", "GSCM Store Type")),
                        m("th", this.getText("LT00000847", "Sold-To Code")),
                        m("th", this.getText("LT00000848", "Sold-To Name")),
                        m(
                          "th",
                          this.getText("LT00000823", "Representative Sold-To Code")
                        ),
                        m("th", this.getText("LT00000849", "Ship-To Code")),
                        m("th", this.getText("LT00000850", "Ship-To Name")),
                        m("th", this.getText("LT00000241", "GSCM Division")),
                        m(
                          "th",
                          this.getText("LT00000851", "Direct Purchase From Samsung")
                        ),
                        m("th", this.getText("LT00000852", "Current M + Last 2M ST QTY")),
                        m("th", this.getText("LT00000853", "GSCM Channel Category")),
                        m("th", this.getText("LT00000816", "GSCM Site Status(s)")),
                        m("th", this.getText("LT00000081", "Create User")),
                        m("th", this.getText("LT00000041", "Create Date")),
                        m("th", this.getText("LT00000305", "Update User")),
                        m("th", this.getText("LT00000306", "Update Date")),
                        m("th", this.getText("LT00000092", "Action"))
                      )
                    ),
                    m(
                      "tbody",
                      soldToShipToMapping.length == 0 &&
                      m(
                        "tr",
                        { class: "align-middle" },
                        m(
                          "td",
                          { colspan: "21" },
                          languageModel.getText(
                            "EM00000141",
                            "No records found."
                          )
                        )
                      ),
                      soldToShipToMapping.map((data, index) =>
                        m(
                          `tr.align-middle${data.remark === EDITABLE_FLAG.EDITABLE
                            ? ".cursor-pointer"
                            : ""
                          }`,
                          data.remark === EDITABLE_FLAG.EDITABLE && {
                            onclick: (event) => {
                              // Triggers select only when user click on the cell
                              if (event.target.localName === "td") {
                                document
                                  .querySelector(`#${CHECKBOX_NAME}${index}`)
                                  .dispatchEvent(new MouseEvent("click"));
                              }
                            },
                          },
                          m(
                            "td",
                            m("input", {
                              id: `${CHECKBOX_NAME}${index}`,
                              type: "checkbox",
                              tabindex: -1,
                              name:
                                data.remark === EDITABLE_FLAG.EDITABLE &&
                                CHECKBOX_NAME,
                              disabled: !(
                                data.remark === EDITABLE_FLAG.EDITABLE
                              ),
                              onchange: (event) => {
                                selectRow(event.target.checked, data);
                              },
                            })
                          ),
                          m("td", m("span.cursor-text", data.imceStore)),
                          m("td", m("span.cursor-text", data.siteId)),
                          m("td", m("span.cursor-text", data.siteName)),
                          m("td", m("span.cursor-text", data.siteGroup)),
                          m("td", m("span.cursor-text", data.storeType)),
                          m(
                            "td",
                            {
                              style:
                                data.shiptoCode
                                  ? {}
                                  : { background: "rgb(255,255,153)" },
                            },
                            m("span.cursor-text", data.soldtoCode)
                          ),
                          m(
                            "td",
                            {
                              style:
                                data.shiptoCode
                                  ? {}
                                  : { background: "rgb(255,255,153)" },
                            },
                            m("span.cursor-text", data.soldtoName)
                          ),
                          m("td", m("span.cursor-text", data.repSoldToCode)),
                          m(
                            "td",
                            {
                              style:
                                data.shiptoCode
                                  ? {}
                                  : { background: "rgb(255,255,153)" },
                            },
                            m("span.cursor-text", data.shiptoCode)
                          ),
                          m(
                            "td",
                            {
                              style:
                                data.shiptoName ?? ""
                                  ? {}
                                  : { background: "rgb(255,255,153)" },
                            },
                            m("span.cursor-text", data.shiptoName)
                          ),
                          m("td", m("span.cursor-text", data.gscmDivision)),
                          m(
                            "td",
                            m(
                              "span.cursor-text",
                              data.distributionStoreType.toUpperCase()
                            )
                          ),
                          m("td", m("span.cursor-text", data.sellthruQuantity)),
                          m(
                            "td",
                            m("span.cursor-text", data.gscmChannelCategory)
                          ),
                          m("td", m("span.cursor-text", data.siteStatus)),
                          m("td", m("span.cursor-text", data.createUserId)),
                          m("td", m("span.cursor-text", data.createDate)),
                          m("td", m("span.cursor-text", data.updateUserId)),
                          m("td", m("span.cursor-text", data.updateDate)),
                          m(
                            "td",
                            data.remark === EDITABLE_FLAG.EDITABLE
                              ? m(
                                'i.bi.bi-pencil-square.list-action-icon[title="Edit"]',
                                {
                                  onclick: () => {
                                    _openModalMapping(_dataMapping(data));
                                  },
                                }
                              )
                              : m(
                                "span.cursor-text",
                                this.getText("LT00008051", "Uneditable (Source from GSCM)")
                              )
                          )
                        )
                      )
                    )
                  )
                )
              ),
              m(
                ".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: onPageChanged,
                  onPageSizeChanged: onPageSizeChanged,
                })
              )
            )
          )
        ),

        // /** CREATE DIALOG */
        isModalMappingOpen &&
        m(SiteSoldToShipToAddView, {
          isModalMappingOpen: isModalMappingOpen,
          data: mappingDetail ?? null,
          onClose: () => {
            isModalMappingOpen = false;
          },
          onSaveComplete: () => {
            isModalMappingOpen = false;
            this.showMessage(this.getText("EM00000004", "Success"));
            _initControls();
          },
        }),

        this.getBaseViews(),

        // /* EXCEL UPLOAD DIALOG */
        m(SiteSoldToShipToMappingExcelUploadDialog, {
          filters,
          isOpen: isExcelUploadOpen,
          onClose: () => {
            isExcelUploadOpen = false;
          },
          onUploaded: () => {
            isExcelUploadOpen = false;
            isExcelUploaded = true;
          },
        }),

        this.getBaseViews(),
      ];
    },
  };
}
